<script>
  import solicitacaoCursoEventoServicoServico from '../servico';

  import DadosConfiguracoes from './compartilhado/FormConfiguracoes.vue';
  import DadosSolicitacao from './compartilhado/FormDadosSolicitacao.vue';
  import DadosAdicionais from './compartilhado/FormDadosAdicionais.vue';
  import DadosAdicionaisDoacoes from './compartilhado/FormDadosAdicionaisDoacoes.vue';
  import DadosProjetos from './compartilhado/FormDadosProjetos.vue';
  import DadosInternacionalizacao from './compartilhado/FormInternacionalizacao.vue';
  import CategoriaValores from './compartilhado/FormCategoriaValores.vue';
  import Questionario from './compartilhado/FormQuestionario.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import Radio from '~componentes/Radio.vue';
  
  export default {
    components: { AdicionarArquivos, DadosConfiguracoes, DadosInternacionalizacao, DadosAdicionais, DadosProjetos, CategoriaValores, Questionario, DadosSolicitacao, ListaDeArquivos, Radio, DadosAdicionaisDoacoes },
    data() {
      return {
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        configuracao: this.$storage.configuracao(),
        arquivos: [], 
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Curso, Evento, Doação ou Serviço - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-curso-evento-servico.nova';

    },
    methods: {
      validarDadosDoacao(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.solicitacao.tipoSolicitacao == 4) return true;

        let msgErro = "";

        const valorMinimo = this.$options.filters.formatarNumero(this.solicitacao.solicitacaoDoacao[0].valorMinimo, true);
        const valorMaximo = this.$options.filters.formatarNumero(this.solicitacao.solicitacaoDoacao[0].valorMaximo, true);

        const valorPadrao1 = this.$options.filters.formatarNumero(this.solicitacao.solicitacaoDoacao[0].valorPadrao1, true);
        const valorPadrao2 = this.$options.filters.formatarNumero(this.solicitacao.solicitacaoDoacao[0].valorPadrao2, true);
        const valorPadrao3 = this.$options.filters.formatarNumero(this.solicitacao.solicitacaoDoacao[0].valorPadrao3, true);
        const valorPadrao4 = this.$options.filters.formatarNumero(this.solicitacao.solicitacaoDoacao[0].valorPadrao4, true);


        if ((valorMinimo > 0) || (valorMaximo > 0)) {

          // Entre dois valores
          if ((valorMinimo > 0) && (valorMaximo > 0)) {

            if ((!msgErro) && (valorMinimo > valorMaximo)) {
              msgErro = "Valor mínimo deve ser menor que o valor máximo";
            }

            if ((!msgErro) && (valorPadrao1 > 0) && ((valorPadrao1 < valorMinimo) || (valorPadrao1 > valorMaximo))) {
              msgErro = '"Valor padrão 1" deve estar entre ' + this.$options.filters.formatarNumero(valorMinimo) +
                ' e ' + this.$options.filters.formatarNumero(valorMaximo);
            }

            if ((!msgErro) && (valorPadrao2 > 0) && ((valorPadrao2 < valorMinimo) || (valorPadrao2 > valorMaximo))) {
              msgErro = '"Valor padrão 2" deve estar entre ' + this.$options.filters.formatarNumero(valorMinimo) +
                ' e ' + this.$options.filters.formatarNumero(valorMaximo);
            }

            if ((!msgErro) && (valorPadrao3 > 0) && ((valorPadrao3 < valorMinimo) || (valorPadrao3 > valorMaximo))) {
              msgErro = '"Valor padrão 3" deve estar entre ' + this.$options.filters.formatarNumero(valorMinimo) +
                ' e ' + this.$options.filters.formatarNumero(valorMaximo);
            }

            if ((!msgErro) && (valorPadrao4 > 0) && ((valorPadrao4 < valorMinimo) || (valorPadrao4 > valorMaximo))) {
              msgErro = '"Valor padrão 4" deve estar entre ' + this.$options.filters.formatarNumero(valorMinimo) +
                ' e ' + this.$options.filters.formatarNumero(valorMaximo);
            }

          }
          else {
            // Entre valor 1
            if (valorMinimo > 0) {
              if ((!msgErro) && (valorPadrao1 > 0) && (valorPadrao1 < valorMinimo)) {
                msgErro = '"Valor padrão 1" deve ser maior que ' + this.$options.filters.formatarNumero(valorMinimo)
              }

              if ((!msgErro) && (valorPadrao2 > 0) && (valorPadrao2 < valorMinimo)) {
                msgErro = '"Valor padrão 2" deve ser maior que ' + this.$options.filters.formatarNumero(valorMinimo)
              }

              if ((!msgErro) && (valorPadrao3 > 0) && (valorPadrao3 < valorMinimo)) {
                msgErro = '"Valor padrão 3" deve ser maior que ' + this.$options.filters.formatarNumero(valorMinimo)
              }

              if ((!msgErro) && (valorPadrao4 > 0) && (valorPadrao4 < valorMinimo)) {
                msgErro = '"Valor padrão 4" deve ser maior que ' + this.$options.filters.formatarNumero(valorMinimo)
              }

            }
            else {
              // Entre valor 2
              if ((!msgErro) && (valorPadrao1 > 0) && (valorPadrao1 > valorMaximo)) {
                msgErro = '"Valor padrão 1" deve ser menor que ' + this.$options.filters.formatarNumero(valorMaximo)
              }

              if ((!msgErro) && (valorPadrao2 > 0) && (valorPadrao2 > valorMaximo)) {
                msgErro = '"Valor padrão 2" deve ser menor que ' + this.$options.filters.formatarNumero(valorMaximo)
              }

              if ((!msgErro) && (valorPadrao3 > 0) && (valorPadrao3 > valorMaximo)) {
                msgErro = '"Valor padrão 3" deve ser menor que ' + this.$options.filters.formatarNumero(valorMaximo)
              }

              if ((!msgErro) && (valorPadrao4 > 0) && (valorPadrao4 > valorMaximo)) {
                msgErro = '"Valor padrão 4" deve ser menor que ' + this.$options.filters.formatarNumero(valorMaximo)
              }
            }
          }
        }

        if (msgErro) {
          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return valido;
      },
      validarDadosAdicionaisCursoEvento(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.$refs.dadosAdicionais) return true;

        if (!this.$refs.dadosAdicionais.validarDadosSolicitacao) {
          $('#tabs a[href="#tab-dados-adicionais"]').tab('show');
          throw new Error("validacao");
          return false;
        }

        return true;
      },
      validarCategoriaValores(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.$refs.categoriaValores) return true;

        if ((this.solicitacao.solicitacaoCursoEventos[0].faixaValores.length > 0) == false) {
          $('#tabs a[href="#tab-categoria-valores"]').tab('show');
          this.$refs.categoriaValores.validar();

          this.$swal(
            '',
            'É necessário informar ao menos uma categoria de valores de inscrição',
            'info'
          );
          throw new Error("validacao");
          return false;
        }

        return true;
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosSolicitacao
          .validarDadosSolicitacao()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-solicitacao"]').tab('show');
              throw new Error("validacao");
              exit;
            }
            
            return valido;
          })
          .then(this.validarDadosAdicionaisCursoEvento)
          .then(this.validarCategoriaValores)
          .then(this.validarDadosDoacao)
          .then(this.$refs.dadosProjetos.validarProjeto)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-projetos"]').tab('show');
              this.$refs.dadosProjetos.validar();

              this.$swal(
              '',
              'É necessário informar um rateio de 100%',
              'info'
              );

              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.validarCadastroCompleto)
          .then(this.validarPermitirEstrangeiros)
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-curso-evento-servico.relatorio', id, 'solicitacao-curso-evento-servico');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolCursoEventoServico || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolCursoEventoServico.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        
        if (this.$route.params.id) {
          return solicitacaoCursoEventoServicoServico.alterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoCursoEventoServicoServico.adicionar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
        }
      },
      camposSolicitacao() {
        return {
          idSolicitacaoCursoEventoServico: '',
          dataSolicitacao: '',
          tipoSolicitacao: '0',
          nomeSolicitante: '',
          emailSolicitante: '',
          telefoneSolicitante: '',
          liberacaoCoordenador: '',
          liberacaoCoordenador2: '',
          idLiberadoCoordenador: '',
          idLiberadoCoordenador2: '',
          idSolicitante: '',
          statusSolicitacao: '',
          descricao: '',
          instituicao: '',
          unidade: '',
          departamento: '',
          siteCursoEvento: '',
          instagramCursoEventoDoacao: '',

          cadastroCompleto : null,
          permitirEstrangeiro : null,
          traduzirIngles : null,
          traduzirEspanhol : null,
          traduzirFrances : null,
          traduzirItaliano : null,

          projetos: [],
          faixaValores: [],
          solicitacaoCursoEventoForms: [],

          solicitacaoDoacao: [{
            idSolicitacaoDoacao: '',
            valorMinimo: '',
            valorMaximo: '',
            valorPadrao1: '',
            valorPadrao2: '',
            valorPadrao3: '',
            valorPadrao4: '',
            descricaoDoacao: '',
          }],
          solicitacaoCursoEventoServicoTraducoes: [{
                "idSolicitacaoCursoEventoServicoTraducoes": null,
                "idSolicitacaoCursoEventoServico": null,
                "idLinguagem": 1,
                "descricao": null,
                "resumo": null,
                "descricaoDoacao": null,
                "mensagemFinalSalvar": null,
                "informacoes": null,
                "observacoes": null,
                "justificativa": null,
                "objetivos": null,
                "metodologia": null,
                "infraestrutura": null,
                "ementaDisciplina": null,
                "investimento": null,
                "local": null,
                "outrasInformacoes": null,
                "duracao": null,
                "areaConhecimento": null,
                "preRequisito": null,
                "publicoAlvo": null,
                "formaPagamento": null,
                "devolucaoInscricao": null
            }],
          solicitacaoDoacao: [{idSolicitacaoDoacao: '',
                                      valorMinimo: '',
                                      valorMaximo: '',
                                      valorPadrao1: '',
                                      valorPadrao2: '',
                                      valorPadrao3: '',
                                      valorPadrao4: ''
                                    }],

          solicitacaoCursoEventos: [{idSolicitacaoCursoEvento: '',
                                      informacoes: '',
                                      observacoes: '',
                                      justificativa: '',
                                      objetivos: '',
                                      metodologia: '',
                                      infraestrutura: '',
                                      ementaDisciplina: '',
                                      local: '',
                                      outrasInformacoes: '',
                                      duracao: '',
                                      areaConhecimento: '',
                                      preRequisito: '',
                                      publicoAlvo: '',
                                      formaPagamento: '',
                                      devolucaoInscricao: '',

                                      alunosMaximo: '',
                                      alunosMinimo: '',
                                      dataInicio: '',
                                      dataFim: '',
                                      dataInicioInscricao: '',
                                      dataLimiteInscricao: '',
                                      dataVencimentoParcela: '',
                                      parcelas: '',
                                      valorParcela: '',
                                      faixaValores: []}],


        };
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoCursoEventoServicoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => solicitacaoCursoEventoServicoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.carregando = false;
          });
      },
      download(arquivo) {
        solicitacaoCursoEventoServicoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
      validarTipoSolicitacao() {
        this.$validator
          .validate('descricao', this.solicitacao.descricao)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(() => {
            if (this.solicitacao.tipoSolicitacao === "0") {
              this.$swal(
              '',
              'É necessário informar um tipo de solicitação (Curso, evento, doação ou serviço).',
              'info'
              );

              throw new Error("validacao");
              exit;
            }

            this.$set(this, 'mostrarFormulario', true);
          })
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      validarCadastroCompleto(valido) {
        if (!valido) throw new Error("validacao com erro");

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.cadastroCompleto == 1) || (this.solicitacao.cadastroCompleto == 0))) {
          validou = false;
        }

        if (!validou) msgErro = `É necessário informar se vai utilizar cadastro completo.`

        if (msgErro) {
          $('#tabs a[href="#tab-configuracoes"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
      validarPermitirEstrangeiros(valido) {
        if (!valido) throw new Error("validacao com erro");

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.permitirEstrangeiro == 1) || (this.solicitacao.permitirEstrangeiro == 0))) {
          validou = false;
        }

        if (!validou) msgErro = `Informar se será permitido o cadastro de estrangeiros.`

        if (this.solicitacao.permitirEstrangeiro == 1) {
            if (!(this.solicitacao.traduzirIngles || this.solicitacao.traduzirEspanhol || this.solicitacao.traduzirFrances || this.solicitacao.traduzirItaliano)){
                validou = false;
                msgErro = `Selecionar pelo menos uma língua.`
            }

            if (validou) {
                if (!this.$refs.dadosInternacionalizacao.validarDadosSolicitacao(valido)) {
                    $('#tabs a[href="#tab-internacionalizacao"]').tab('show');
                    validou = false;
                    if (!valido) throw new Error("validacao");
                } 
            }
        }

        if (msgErro) {
          $('#tabs a[href="#tab-internacionalizacao"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else 
            return validou;
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }

      this.mostrarInstrucoes();
    },
    watch: {
    },
    computed: {
      labelDesricao() {
        if (parseInt(this.solicitacao.tipoSolicitacao) == 1) {
          return 'Nome do curso';
        }
        if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
          return 'Nome do evento';
        }
        return 'Descrição';
      },
    },
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarTipoSolicitacao">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>
          
          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-solicitacao">
                  Dados solicitação
                </a>
              </li>

              <li>
                <a data-toggle="tab"
                   href="#tab-dados-adicionais">
                  Dados adicionais
                </a>
              </li>

              <li v-if="((this.solicitacao.tipoSolicitacao == 1) || (this.solicitacao.tipoSolicitacao == 2))">
                <a data-toggle="tab"
                   href="#tab-categoria-valores">
                  Categoria de valores
                </a>
              </li>

              <li>
                <a data-toggle="tab"
                   href="#tab-dados-projetos">
                  Projetos
                </a>
              </li>

              <li>
                <a data-toggle="tab"
                   href="#tab-questionario">
                  Questionário
                </a>
              </li>

              <li>
                <a data-toggle="tab"
                   href="#tab-configuracoes">
                  Configurações
                </a>
              </li>

              <li>
                <a data-toggle="tab"
                   href="#tab-internacionalizacao">
                  Internacionalização
                </a>
              </li>

              <li v-if="configuracao.usarArquivosSolicitacaoCursoEventoServico">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>

              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoCursoEventoServico">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-solicitacao" class="tab-pane active">
                <div class="panel-body">
                  <dados-solicitacao ref="dadosSolicitacao"
                                     :solicitacao="solicitacao"
                                     :edicao="!!$route.params.id">
                  </dados-solicitacao>
                </div>
              </div>

              <div id="tab-dados-adicionais" class="tab-pane" v-if="((this.solicitacao.tipoSolicitacao == 1) || (this.solicitacao.tipoSolicitacao == 2))">
                <div class="panel-body">
                  <dados-adicionais ref="dadosAdicionais"
                                    :solicitacao="solicitacao"
                                    :edicao="!!$route.params.id">
                  </dados-adicionais>
                </div>
              </div>

              <div id="tab-categoria-valores" class="tab-pane" v-if="((this.solicitacao.tipoSolicitacao == 1) || (this.solicitacao.tipoSolicitacao == 2))">
                <div class="panel-body">
                  <categoria-valores ref="categoriaValores"
                                     :solicitacao="solicitacao"
                                     :edicao="!!$route.params.id">
                  </categoria-valores>
                </div>
              </div>

              <div id="tab-dados-adicionais" class="tab-pane" v-if="(this.solicitacao.tipoSolicitacao == 4)">
                <div class="panel-body">
                  <dados-adicionais-doacoes ref="dadosAdicionaisDoacoes"
                                            :solicitacao="solicitacao"
                                            :edicao="!!$route.params.id">
                  </dados-adicionais-doacoes>
                </div>
              </div>

              <div id="tab-dados-projetos" class="tab-pane">
                <div class="panel-body">
                  <dados-projetos ref="dadosProjetos"
                                  :solicitacao="solicitacao"
                                  :edicao="!!$route.params.id">
                  </dados-projetos>
                </div>
              </div>

              <div id="tab-questionario" class="tab-pane">
                <div class="panel-body">
                  <questionario ref="questionario"
                                :solicitacao="solicitacao"
                                :edicao="!!$route.params.id">
                  </questionario>
                </div>
              </div>

              <div id="tab-configuracoes" class="tab-pane">
                <div class="panel-body">
                  <dados-configuracoes ref="dadosConfiguracoes"
                                       :solicitacao="solicitacao"
                                       :edicao="!!$route.params.id">
                  </dados-configuracoes>
                </div>
              </div>

              <div id="tab-internacionalizacao" class="tab-pane">
                <div class="panel-body">
                  <dados-internacionalizacao ref="dadosInternacionalizacao"
                                       :solicitacao="solicitacao"
                                       :edicao="!!$route.params.id">
                  </dados-internacionalizacao>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      
      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-10">
          <div class="form-group required" :class="{'has-error': errors.has('descricao')}">
            <label class="control-label" for="documento">{{ labelDesricao }}</label>

            <input type="text"
                   class="form-control"
                   id="descricao"
                   v-model="solicitacao.descricao"
                   data-vv-as=" "
                   data-vv-name="descricao"
                   maxlength="200"
                   v-validate="'required'">

            <p class="text-danger" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</p>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group required" :class="{'has-error': errors.has('tipo')}">
            <label class="control-label block">Tipo solicitação</label>

            <radio v-model="solicitacao.tipoSolicitacao"
                   selected-value="1"
                   type="success"
                   :inline="true"
                   class="margin-right-10">
              Curso
            </radio>
            <radio v-model="solicitacao.tipoSolicitacao"
                   selected-value="2"
                   type="success"
                   :inline="true"
                   class="margin-right-10">
              Evento
            </radio>
            <radio v-model="solicitacao.tipoSolicitacao"
                   selected-value="3"
                   type="success"
                   v-if="false"
                   :inline="true">
              Serviço
            </radio>
            <radio v-model="solicitacao.tipoSolicitacao"
                   selected-value="4"
                   type="success"
                   :inline="true">
              Doação
            </radio>

            <p class="text-danger" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default"
                         :to="{ name: 'solicitacao-curso-evento-servico' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button id="avancar"
                    type="button"
                    class="btn btn-primary"
                    @click="validarTipoSolicitacao"
                    v-show="!mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar
              <i class="fa fa-arrow-right"></i>
            </button>

            <button type="button"
                    class="btn btn-default"
                    @click="mostrarFormulario = false, resetarComponente()"
                    v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    @click="salvar"
                    v-show="mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/SolicitacaoCursoEventoServicoForm.vue